import { type FC, type ReactNode } from "react"
import styled, { css } from "styled-components"

import Form from "@forento/shared-client/components/Form"

type Props = { title: string; onSubmit?(): void; horizontal?: boolean; fullWidth?: boolean; children: ReactNode }

const Group: FC<Props> = ({ title, onSubmit, horizontal = false, fullWidth = false, children }) => {
	const content = (
		<>
			<Title>{title}</Title>
			<Content $horizontal={horizontal}>{children}</Content>
		</>
	)

	return onSubmit !== undefined ? (
		<Container as={Form} onSubmit={onSubmit} $fullWidth={fullWidth}>
			{content}
		</Container>
	) : (
		<Container $fullWidth={fullWidth}>{content}</Container>
	)
}

const Container = styled.div<{ $fullWidth: boolean }>`
	background-color: white;
	box-shadow: 0px 4px 30px 0px rgba(223, 232, 255, 0.25);
	padding: 18px 26px 42px;
	display: flex;
	flex-direction: column;

	${props =>
		props.$fullWidth &&
		css`
			grid-column: 1 / -1;
		`}
`

const Title = styled.h2`
	font-family: Quicksand;
	font-size: 14px;
	font-weight: bold;
	margin-bottom: 32px;
`

const Content = styled.div<{ $horizontal: boolean }>`
	flex-grow: 1;
	background: white;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 24px;

	@media (min-width: 1000px) {
		flex-direction: ${props => (props.$horizontal ? "row" : "column")};

		${props =>
			props.$horizontal &&
			css`
				align-items: center;
				flex-wrap: wrap;
			`}
	}
`

export default Group
